import cn from 'classnames';

type LabelProps = {
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
} & Omit<React.LabelHTMLAttributes<HTMLLabelElement>, 'children' | 'className' | 'htmlFor'>;

const Label: React.FC<LabelProps> = ({
  className,
  children,
  htmlFor,
  ...rest
}) => {
  const classes = cn(
    'block text-body-dark font-semibold text-sm leading-none mb-3',
    className,
  );

  if (htmlFor) {
    return (
      <label htmlFor={htmlFor} className={classes} {...rest}>
        {children}
      </label>
    );
  }

  // Visual-only caption when no control id is provided (avoids unlabeled <label>).
  return <div className={classes}>{children}</div>;
};

export default Label;
